import { ReactNode } from "react";
import { SnackbarProvider, MaterialDesignContent } from "notistack";
import styled from "@emotion/styled";

interface IProps {
    children: ReactNode;
}

const ToastProvider: React.FC<IProps> = ({ children }): JSX.Element => {
    const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
        '&.notistack-MuiContent-warning': {
            backgroundColor: '#FA8C16',
        },
        '&.notistack-MuiContent-info': {
            backgroundColor: '#FA8C16',
        }
    }));
    return <SnackbarProvider
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        Components={{
            warning: StyledMaterialDesignContent,
            info: StyledMaterialDesignContent
        }}
    >
        {children}
    </SnackbarProvider>;
};

export default ToastProvider;
